module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-henkel-block-1-00369c43be7b5a1ae41460e7b69efe67.jpg";